import React, { useState } from 'react'
import requests from '../../axios/requests'
import { Popconfirm, Tooltip } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import variableLanguage from '../../../utils/hookGetVariablesLanguage'
import cn from 'classnames'

import { ReactComponent as Sidebar_1 } from '../../../images/sidebar/sidebar_1.svg'
import { ReactComponent as Sidebar_2 } from '../../../images/sidebar/sidebar_2.svg'
import icon_button from '../../../images/sidebar/icon_added_button.svg'
import { ReactComponent as MyCourse } from '../../../images/icons/my_course.svg'
import { ReactComponent as Notification } from '../../../images/icons/navbar_notification.svg'
import { ReactComponent as FreelanceIcon } from '../../../images/icons/freelance_icon.svg'
import { ReactComponent as MailIcon } from '../../../images/icons/mail.svg'
import { ReactComponent as GenerateCourse } from '../../../images/generate_course/generate_course.svg'
import fake_photos from '../../../images/fake_photos.png'
import nav_bar_exit from '../../../images/icons/sidebar_logout.svg'

import { setShowBuyModal } from '../../redux/actions/actions'
import { changeLanguage } from '../../redux/actions/authorizationActions'
import Transition from '../Sidebar/Transition/Transition'

import './SidebarMobile.scss'

const SidebarMobile = (props) => {
  const variable_1 = variableLanguage({ keyPage: 'sidebar', keyVariable: 'variable_1' })
  const variable_2 = variableLanguage({ keyPage: 'sidebar', keyVariable: 'variable_2' })
  const variable_3 = variableLanguage({ keyPage: 'sidebar', keyVariable: 'variable_3' })
  const variable_4 = variableLanguage({ keyPage: 'sidebar', keyVariable: 'variable_4' })
  const variable_5 = variableLanguage({ keyPage: 'sidebar', keyVariable: 'variable_5' })
  const variable_6 = variableLanguage({ keyPage: 'sidebar', keyVariable: 'variable_6' })
  const variable_7 = variableLanguage({ keyPage: 'sidebar', keyVariable: 'variable_7' })
  const variable_8 = variableLanguage({ keyPage: 'sidebar', keyVariable: 'variable_8' })
  const variable_9 = variableLanguage({ keyPage: 'sidebar', keyVariable: 'variable_9' })
  const variable__6 = variableLanguage({ keyPage: 'navbar', keyVariable: 'variable_6' })
  const variable_11 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variable_11',
  })
  const variable_14 = variableLanguage({
    keyPage: 'navbar',
    keyVariable: 'variables_14',
  })
  const { flagHiddenFotter, userPhoto } = props
  const { user, collapse } = useSelector((state) => state.Reducer)
  const [changeLanguageFlag, setChangeLanguageFlag] = useState(false)
  const dispatch = useDispatch()
  const history = useNavigate()
  const location = useLocation()

  let handleLogOut = () => {
    requests.users
      .logout()
      .then(() => {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('username')
        window.localStorage.removeItem('last_name')
        window.localStorage.removeItem('middle_name')
        window.localStorage.removeItem('fio')
        window.localStorage.removeItem('id')
        window.localStorage.removeItem('count_notification')
      })
      .catch((error) => {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('username')
        window.localStorage.removeItem('last_name')
        window.localStorage.removeItem('middle_name')
        window.localStorage.removeItem('fio')
        window.localStorage.removeItem('id')
        window.localStorage.removeItem('count_notification')
      })
      .finally(() => history('/student/auth'))
  }
  return (
    <>
      {location.pathname === '/backoffice/skill-set/prof-review' && (
        <div
          className={cn('added_generation', {
            show: flagHiddenFotter === null || flagHiddenFotter === true,
          })}
          onClick={() => dispatch(setShowBuyModal(true))}
        >
          <img src={icon_button} alt="icon_button" />
          <span>{variable_9}</span>
        </div>
      )}
      <div
        className={
          flagHiddenFotter === null || flagHiddenFotter === true
            ? 'sidebar_mobile show'
            : 'sidebar_mobile'
        }
      >
        <div className="item" onClick={() => history('/notification')}>
          <div className="item_icon none_background">
            <Notification
              className={location?.pathname.includes('/notification') ? 'active' : ''}
            />
          </div>
          <div className="item_label">{variable_4}</div>
        </div>
        <div className="item" onClick={() => history('/student/profile')}>
          <div
            // className="item_icon"
            className={location?.pathname.includes('/profile') ? 'item_icon active2' : 'item_icon'}
          >
            <img src={user?.avatar || userPhoto || fake_photos} />
          </div>
          <div className="item_label">{variable_3}</div>
        </div>
        <div
          className="item"
          onClick={() => {
            history('/student/search-experts')
          }}
        >
          <div
            className={
              location?.pathname === '/student/search-experts' ? 'item_icon active2' : 'item_icon'
            }
          >
            <FreelanceIcon />
          </div>
          <div className="item_label">{variable_7}</div>
        </div>
        {/* <div className="item" onClick={() => history('/')}>
          <div className="item_icon">
            <Sidebar_1 className={location?.pathname === '/' ? 'active' : ''} />
          </div>
          <div className="item_label">{variable_1}</div>
        </div> */}
        <div className="item" onClick={() => history('/backoffice/skill-set/prof-review')}>
          <div
            // className="item_icon"
            className={
              location?.pathname === '/backoffice/skill-set/prof-review'
                ? 'item_icon active2'
                : 'item_icon'
            }
          >
            <Sidebar_1 />
          </div>
          <div className="item_label">{variable_5}</div>
        </div>
        <div className="item" onClick={() => history('/student/my-courses')}>
          <div className="item_icon">
            <MyCourse className={location?.pathname === '/student/my-courses' ? 'active' : ''} />
          </div>
          <div className="item_label">{variable_6}</div>
        </div>
        <div className="item" onClick={() => history('/student/course-list')}>
          <div
            className={
              location?.pathname === '/student/course-list' ? 'item_icon active2' : 'item_icon'
            }
          >
            <Sidebar_2 />
          </div>
          <div className="item_label">{variable_2}</div>
        </div>
        <Tooltip placement="right" title={`${variable_14} support@skillometer.ru`}>
          <div className="support_bar" tabIndex={0}>
            <MailIcon className="support-icon" />
            <Transition show={collapse}>
              <div className="support-text">
                <div>{variable_14}</div>
                <div>support@skillometer.ru</div>
              </div>
            </Transition>
          </div>
        </Tooltip>
        <div
          className="change_parent"
          tabIndex={0}
          onClick={() => setChangeLanguageFlag(!changeLanguageFlag)}
          onBlur={() => setChangeLanguageFlag(false)}
        >
          <div className={changeLanguageFlag ? 'change_language open' : 'change_language'}>
            {!changeLanguageFlag && (
              <div className="active">
                {localStorage.getItem('language') === 'en' ? 'EN' : 'RU'}
              </div>
            )}
            {changeLanguageFlag && (
              <>
                <div
                  className={localStorage.getItem('language') === 'ru' && 'active'}
                  onClick={() => {
                    dispatch(changeLanguage('ru'))
                    localStorage.setItem('language', 'ru')
                    setChangeLanguageFlag(false)
                  }}
                >
                  RU
                </div>
                <div
                  className={localStorage.getItem('language') === 'en' && 'active'}
                  onClick={() => {
                    dispatch(changeLanguage('en'))
                    localStorage.setItem('language', 'en')
                    setChangeLanguageFlag(false)
                  }}
                >
                  EN
                </div>
              </>
            )}
            {collapse && <span className="change_language-collapse">{variable_11} </span>}
          </div>
        </div>
        <div className="item">
          <div className="item_icon">
            <Popconfirm
              title={variable__6}
              onConfirm={() => handleLogOut()}
              okText="Да"
              cancelText="Нет"
            >
              <img src={nav_bar_exit} width={38} height={38} />
            </Popconfirm>
          </div>
          <div className="item_label">{variable_8}</div>
        </div>
      </div>
    </>
  )
}

export default SidebarMobile
